<template>
  <div class="app-container home">
    <h3 style="text-align: center">Warranty Inquiry</h3>
    <el-form :model="queryParams" ref="queryForm" size="small">
      <el-form-item label="Please Enter Product S/N" prop="snCode" :inline="false">
        <el-input v-show="false"/>
        <el-input v-model.trim="queryParams.snCode" placeholder="Enter SN" style="width: 25vw" clearable @keyup.enter.native="handleQuery">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click.native="handleQuery">Search</el-button>
      </el-form-item>
    </el-form>
    <div v-show="warrantyResultShow">
      <div v-if="warrantyResult.warrantyStatus === '3' || warrantyResult.warrantyStatus === '4'">
        <div style="text-align: center; line-height: 50px">
          The device is not activated, please activate the quality assurance first!
        </div>
      </div>
      
      <div v-if="warrantyResult.warrantyStatus !== '4'" class="table-content">
        <div>
          <div>Product Model</div>
          <div>{{ warrantyResult.productModel || '/'}}</div>
        </div>
        <div>
          <div>Warranty Period/Year</div>
          <div>{{ warrantyResult.warrantyYear || '/'}}</div>
        </div>
        <div>
          <div>Warranty Start Time</div>
          <div>{{ warrantyResult.warrantyBegin || '/'}}</div>
        </div>
        <div>
          <div>Warranty Expires</div>
          <div>{{ warrantyResult.warrantyEnd || '/'}}</div>
        </div>
        <div>
          <div>Remaining Warranty Days</div>
          <div>{{ warrantyResult.warrantyRemain || '/'}}</div>
        </div>
      </div>
       <div class="box-download">
          <div><button class="button-content" @click="Downloadclick">Download File</button></div>
        </div>
    </div>

    <div ref="pdfContent" class="certificate" style="display: none;">
      <!-- <h1>LIVOLTEK</h1>
      <h2>Certificado de Garantía</h2> -->
      <div class="box-contentx">
         <div class="field">
        <label>Serial Number:</label>
        <div class="value">{{ warrantyResult.serialNumber || '/' }}</div>
      </div>

      <div class="field">
        <label>Product Model:</label>
        <div class="value">{{ warrantyResult.productModel || '/' }}</div>
      </div>

      <div class="field">
        <label>Warranty Period/Year:</label>
        <div class="value">{{ warrantyResult.warrantyYear || '/' }}</div>
      </div>
      
      <div class="field">
        <label>Warranty Start Time:</label>
        <div class="value">{{ warrantyResult.warrantyBegin || '/' }}</div>
      </div>
      <div class="field">
        <label>Warranty Expires:</label>
        <div class="value">{{ warrantyResult.warrantyEnd || '/' }}</div>
      </div>
      <div class="field">
        <label>Remaining Warranty Days:</label>
        <div class="value">{{ warrantyResult.warrantyRemain || '/' }}</div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import {searchWarranty} from '@/api/foundation/saleout';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
export default {
  name: "Index",
  data() {
    return {
      version: "3.8.6",
      queryParams: {
        snCode: '',
      },
      loading:false,
      warrantyResultShow: false,
      warrantyResult: {},
      // 背景图片URL - 替换为实际的背景图片地址 
      backgroundImageUrl: require('@/assets/img/13.png'),

      warrantyStatus: {
        1: 'Under warranty',
        2: 'Expired warranty',
        3: 'Logout',
        4: 'unknown'
      }
    };
  },
  methods: {
    handleQuery() {
      if (this.queryParams.snCode) {
        searchWarranty(this.queryParams.snCode).then(res => {
          this.warrantyResult = {}
          this.warrantyResult.serialNumber = this.queryParams.snCode
          if (res.data == null) {
            this.warrantyResult.warrantyStatus = '4';
          } else {
            this.warrantyResult = res.data
          }
          this.warrantyResultShow = true
          this.$message.success("Query successful");
        })
      } else {
        this.warrantyResultShow = false
      }
    },

    // async Downloadclick() {
    //   try {
    //     this.loading = true;
        
    //     // 创建一个离屏的div来渲染内容
    //     const offscreenDiv = document.createElement('div');
    //     offscreenDiv.style.position = 'absolute';
    //     offscreenDiv.style.left = '-9999px';
    //     // offscreenDiv.style.left = '0';
    //     offscreenDiv.style.top = '0';
    //     offscreenDiv.style.width = '210mm';
    //     offscreenDiv.style.height = '297mm';
    //     offscreenDiv.style.background = 'white';
        
    //     // 克隆模板内容
    //     const template = this.$refs.pdfContent.cloneNode(true);
    //     template.style.display = 'block';
    //     // 添加背景图片样式
    //     template.style.backgroundImage = `url(${this.backgroundImageUrl})`;
    //     template.style.backgroundSize = 'cover';
    //     template.style.backgroundPosition = 'center';
    //     template.style.backgroundRepeat = 'no-repeat';
        
    //     offscreenDiv.appendChild(template);
    //     document.body.appendChild(offscreenDiv);
        
    //     // 使用html2canvas捕获离屏DOM
    //     const canvas = await html2canvas(offscreenDiv.querySelector('.certificate'), {
    //       scale: 2,
    //       logging: false,
    //       useCORS: true,
    //       allowTaint: true
    //     });
        
    //     // 移除离屏div
    //     document.body.removeChild(offscreenDiv);
        
    //     // 创建PDF
    //     const pdf = new jsPDF({
    //       orientation: 'portrait',
    //       unit: 'mm',
    //       format: 'a4'
    //     });
        
    //     // 计算图片在PDF中的尺寸
    //     const imgData = canvas.toDataURL('image/png');
    //     const imgProps = pdf.getImageProperties(imgData);
    //     const pdfWidth = pdf.internal.pageSize.getWidth();
    //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
    //     // 添加图片到PDF
    //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);  
        
    //     // 保存PDF
    //     pdf.save('Certificado_de_Garantia_LIVOLTEK.pdf');
        
    //   } catch (error) {
    //     console.error('生成PDF失败:', error);
    //     this.$toast.error('生成PDF时出错');
    //   } finally {
    //     this.loading = false;
    //   }
    // },

async Downloadclick() {
  try {
    this.loading = true;
        
    const offscreenDiv = document.createElement('div');
    offscreenDiv.style.position = 'absolute';
    offscreenDiv.style.left = '-9999px';
    offscreenDiv.style.top = '0';
    offscreenDiv.style.width = '210mm';
    offscreenDiv.style.height = '297mm';
    offscreenDiv.style.background = 'white';
        
    const template = this.$refs.pdfContent.cloneNode(true);
    template.style.display = 'block';
    template.style.backgroundImage = `url(${this.backgroundImageUrl})`;
    template.style.backgroundSize = 'cover';
    template.style.backgroundPosition = 'center';
    template.style.backgroundRepeat = 'no-repeat';
        
    offscreenDiv.appendChild(template);
    document.body.appendChild(offscreenDiv);
        
    // 调整参数以获得约1MB大小的PDF
    const canvas = await html2canvas(offscreenDiv.querySelector('.certificate'), {
      scale: 1.5, // 提高缩放比例（增加分辨率）
      logging: false,
      useCORS: true, // 确保背景图正确加载
      allowTaint: false,
      dpi: 150 // 中等DPI，平衡质量和大小
    });
        
    document.body.removeChild(offscreenDiv);
        
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });
        
    // 提高JPEG质量（0.8-0.9之间）
    const imgData = canvas.toDataURL('image/jpeg', 0.85); // 质量系数适中
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
    pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);  
    pdf.save('Warranty' + 'certificate' + this.warrantyResult.serialNumber + '.pdf');
        
  } catch (error) {
    console.error('生成PDF失败:', error);
    this.$toast.error('生成PDF时出错');
  } finally {
    this.loading = false;
  }
},

  }

};
</script>
<style lang="scss">
.tagClass{
}
.app-container {
  max-width: 1000px;
  margin: 0 auto;
  border: 2px solid #AFD5DA;
  padding: 20px;
  box-sizing: border-box;
  h3 {
    position: relative;
    line-height: 50px;
    &:after {
      content: '';
      width: 160px;
      height: 2px;
      border-bottom: 2px solid #AFD5DA;
      position: absolute;
      left: 0;
      right:0;
      margin: auto;
      bottom: 0;
    }
  }
  .el-form-item__label {
    float: none;
  }
  .el-input {
    width: 100% !important;
  }
  .el-input__inner {
    width: 100%;
  }
  .el-button {
    color: #fff;
    background: #000;
    border-radius: 0;
    &:hover,&:focus {
      color: #fff;
      background: #000;
      border-radius: 0;
    }
  }
  .table-content {
    display: flex;

    > div {
      width: 20%;
      &:nth-of-type(1) {
        div {
          &:nth-of-type(2) {
            border-left: 1px solid #dedede;
          }
        }
      }
      div {
        border-bottom: 1px solid #dedede;
        &:nth-of-type(1) {
          background: #000;
          color: #fff;
          font-size: 13px;
          height: 40px;
          line-height: 40px;
          text-indent: 5px;
          border-right: 1px solid #dedede;

        }
        &:nth-of-type(2) {
          background: #f8f8f8;
          font-size: 13px;
          height: 40px;
          line-height: 40px;
          text-indent: 5px;
          border-right: 1px solid #dedede;
        }
        &:nth-of-type(6) {
          border-right: none;
        }
      }
    }
    @media(max-width: 768px) {
      display: block;
      > div {
        width: 100%;
      }
    }
  }
  .box-download{
    display: flex;
    justify-content:center;
    align-items: center;
    padding-top:30px;
  }
  .button-content{
    text-align:center !important;
    height:32px !important;
    line-height: 32px !important;
  }
}

.generate-btn {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 20px;
}

.generate-btn:hover {
  background-color: #45a049;
}
.certificate {
  width: 210mm;
  min-height: 297mm;
  /* 恢复水平居中的外边距 */
  // margin: 0 auto;
  /* 如果需要内部文本内容居中 */
  display: flex;
  align-content: center;
  justify-content: center; /* 可选，同时实现水平居中 */
  // flex-direction: column;
  text-align:left;
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  position: relative;
  color: #000; /* 确保文本颜色与背景对比明显 */
}

/* 可以添加半透明覆盖层使文本更易读 */
.certificate::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: rgba(255, 255, 255, 0.7); /* 轻微的白色覆盖层增加文本可读性 */
  z-index: 0;
}

.certificate > * {
  position: relative;
  z-index: 1; /* 确保内容显示在背景之上 */
}

// .certificate h1 {
//   text-align: center;
//   font-size: 24pt;
//   margin-bottom: 10px;
//   color: #333;
// }

// .certificate h2 {
//   text-align: center;
//   font-size: 18pt;
//   margin-bottom: 30px;
//   color: #555;
// }

.field {
  padding:25px;
  padding-left:300px;
  page-break-inside: avoid;

}

.field label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  font-size: 12pt;
}

.field .value {
  // border-bottom: 1px solid #ddd;
  // padding-bottom: 5px;
  min-height: 20px;
  font-size: 12pt;
}
</style>
